import * as React from 'react';
import {connect} from 'react-redux';
import SplitPane from 'react-split-pane';

import PropTypes from 'prop-types';
import _ from 'underscore';

import * as actions from '../dashboard-actions';
import * as selectors from '../dashboard-selectors';

import {DashboardPaneLeft} from './dashboard-pane-left';
import {DashboardPaneRight} from './dashboard-pane-right';

import styles from './dashboard-panes.module.css';

const MIN_CARDS_WIDTH = 325;

const mapStateToProps = function (state) {
    return {
        rightPaneSize: selectors.getRightPaneWidth(state),
    };
};

const mapDispatchToProps = function (dispatch) {
    return {
        onDashSizeChange: (width) => {
            dispatch(actions.resizeRightPaneWidth(width));
        },
        onSidebarSnapOpen: () => {
            dispatch(actions.snapSidebarOpen());
        },
        onSidebarUnsnapOpen: () => {
            dispatch(actions.unsnapSidebarOpen());
        },
    };
};

export class DashboardPanesComponent extends React.Component {
    static propTypes = {
        rightPaneSize: PropTypes.number.isRequired,
        onDashSizeChange: PropTypes.func.isRequired,
        onSidebarSnapOpen: PropTypes.func.isRequired,
        onSidebarUnsnapOpen: PropTypes.func.isRequired,
    };

    constructor(props) {
        super(props);
        this.state = {
            width: undefined,
            dragging: false,
        };
    }

    render() {
        return (
            <div
                ref={(c) => {
                    this.splPane = c;
                }}
            >
                <SplitPane
                    split='vertical'
                    primary='second'
                    defaultSize={this.props.rightPaneSize}
                    onChange={this.handleDashSizeChange}
                    onDragStarted={this.handleDragStart}
                    onDragFinished={this.handleDragEnd}
                    size={this.state.dragging ? undefined : this.state.width}
                    minSize={400}
                    maxSize={-10} /* This will leave 10px of secondary pane showing */
                    className={styles['split-pane']}
                >
                    <DashboardPaneLeft />
                    <DashboardPaneRight />
                </SplitPane>
            </div>
        );
    }

    handleDragStart = () => {
        this.setState({
            dragging: true,
        });
    };

    handleDragEnd = () => {
        this.setState({
            dragging: false,
        });
        setTimeout(() => {
            this.setState({width: undefined});
        }, 1000);
    };

    handleDashSizeChange = _.debounce((width) => {
        const totalWidth = this.splPane.getBoundingClientRect().width;
        const leftWidth = totalWidth - width;
        if (leftWidth < MIN_CARDS_WIDTH) {
            const snappedWidth = totalWidth - 15;
            this.setState({width: snappedWidth});
            this.props.onDashSizeChange(snappedWidth);
            this.props.onSidebarSnapOpen();
        } else {
            this.props.onDashSizeChange(width);
            this.props.onSidebarUnsnapOpen();
        }
    }, 200);
}

export const DashboardPanes = connect(mapStateToProps, mapDispatchToProps)(DashboardPanesComponent);
